import React from 'react';
import styles from './commonComponents.module.scss';

export default function SectionLabel({ children }) {
  return <label className={styles.section_label}>{children}</label>;
}
